export default "__VITE_ASSET__BjanNRIQ__"